module.exports = __webpack_public_path__ + "st-lucia.svg?d451e533859469a32ce5c9bda3a10223";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/st-lucia.svg
// module id = 305
// module chunks = 10